export default {
  'workforce.title': '员工报表',
  'workforce.editTimeSheet': '编辑打卡记录',
  'workforce.filterByRoles': '按角色筛选',
  'workforce.filterByDepartments': '按部门筛选',
  'workforce.filterByEmployee': '搜索员工',
  'workforce.filterByOrderSource': '按订单来源筛选',
  'workforce.laborSummaryDescription':
    '请勿将此页直接用于发放员工薪资，因为该页并未包含小费收入和扣除个人税，并且可能不包含所有加班费。',
  'workforce.filter.date': '日期',
  'workforce.filter.employee': '员工',
  'workforce.filter.serviceType': '服务类型',
  'workforce.filter.role': '角色',
  'workforce.filter.orderSource': '订单来源',
  'workforce.action.add': '新增打卡记录',
  'workforce.action.export': '导出',

  'workforce.column.clock_date': '日期',
  'workforce.column.first_name': '姓名',
  'workforce.column.employee': '员工',
  'workforce.column.role': '角色',
  'workforce.column.department': '部门',
  'workforce.column.clock_in': '上班打卡',
  'workforce.column.formatted_clock_in': '上班打卡',
  'workforce.column.formatted_clock_out': '下班打卡',
  'workforce.column.clock_out': '下班打卡',
  'workforce.column.regular_duration': '工作时长',
  'workforce.column.over_time_duration': '加班时长',
  'workforce.column.clock_duration': '总工作时长',
  'workforce.column.hours_worked': '工作时长',
  'workforce.column.number_of_employees': '员工数',
  'workforce.column.hourly_rate': '时薪',
  'workforce.column.total_pay': '总薪资',
  'workforce.column.paid_break_duration': '带薪休息时长',
  'workforce.column.unpaid_break_duration': '无薪休息时长',
  'workforce.column.action': '操作',
  'workforce.column.clockTime': '打卡时间',
  'workforce.column.break': '休息记录',
  'workforce.column.total_hours_worked': '总工作时长',
  'workforce.column.duration': '打卡时长',
  'workforce.column.break_start': '休息开始时间',
  'workforce.column.break_end': '休息结束时间',
  'workforce.column.overtime_rate_factor': '加班时长（{rate}x）',
  'workforce.column.description.regular_duration': `
    <p>
      总工作时长减去加班时长。
    </p>
    <p style="margin-bottom: 0px">
      工作时长包含带薪休息但不包含无薪休息。
    </p>
  `,
  'workforce.column.description.over_time_duration': '加班时长根据配置的加班规则计算，展示为“加班工资系数: 加班时长”',
  'workforce.column.description.total_hours_worked': '总工作时长 = 工作时长 + 加班时长',
  'workforce.column.description.paid_break_duration': '被计算为工作时长',
  'workforce.column.description.unpaid_break_duration': '不计算在工作时长内',
  'workforce.column.description.formatted_clock_out': `
    <p>
      请检查并确认异常记录
    </p>
    <div>
      <div style="margin-bottom: 8px">
        <span class="icon-error"></span>
        打卡时长超过24小时
      </div>
      <div style="margin-bottom: 0px">
        <span class="icon-warn"></span>
        自动打卡下班
      </div>
    </div>
  `,
  'workforce.employee.isRequired': '请选择员工',
  'workforce.date.isRequired': '请选择日期',
  'workforce.clockTime.isRequired': '请选择打卡时间',
  'workforce.clock_in.isRequired': '请选择上班打卡时间',
  'workforce.clock_out.isRequired': '请选择下班打卡时间',

  'workforce.cancelEdit.confirm': '确认取消吗？',

  'workforce.deletion.promptTitle': '删除提示',
  'workforce.deletion.promptContent': '确认要删除此条打卡记录吗？',
  'workforce.clock_in.exceed': '上班打卡时间必须早于下班打卡时间',
  'workforce.clock_out.exceed': '下班打卡时间必须晚于上班打卡时间',
  'workforce.duration.format': '{hours}时{minutes}分',
  'workforce.editBreakTime': '编辑休息时间',
  'workforce.updateTimeSheetSuccess': '更新打卡记录成功',
  'workforce.breakOverlap': '休息时间冲突',
  'workforce.breakStartShouldAfterClockIn': '休息开始时间必须晚于上班打卡时间',
  'workforce.breakEndShouldBeforeClockOut': '休息结束时间必须早于下班打卡时间',
  'workforce.exceedRange': '休息时间应在上班打卡时间和下班打卡时间之间',
  'workforce.breakHasEmpty': '休息开始/结束时间为空',
  'workforce.breakStart.exceed': '休息开始时间必须早于结束时间',
  'workforce.breakEnd.exceed': '休息结束时间必须晚于开始时间',
  'workforce.action.confirmClockOut': '确认下班打卡时间',

  'workforce.column.duration_h': '打卡时长 (小时)',
  'workforce.column.unpaid_break_duration_h': '无薪休息时长 (小时)',
  'workforce.column.paid_break_duration_h': '带薪休息时长 (小时)',
  'workforce.column.clock_duration_h': '总工作时长 (小时)',
  'workforce.column.over_time_duration_h': '加班时长 (小时)',
  'workforce.column.regular_duration_h': '工作时长 (小时)',
  'workforce.column.total_hours_worked_h': '总工作时长 (小时)',
  'workforce.column.overtime_rate_factor_h': '加班时长 (小时)（{rate}x）',
  'workforce.column.hours_worked_h': '工作时长 (小时)',
};
